jQuery(document).ready(function($) {
    // Fixed header on scroll
    $(window).scroll(function() {
        if ($(window).scrollTop() > 20) {
            $('.header').addClass('fixed-top');
            $('body').addClass('header-fixed'); 
        } else {
            $('.header').removeClass('fixed-top');
            $('body').removeClass('header-fixed');
        }
    });

    // Mobile menu toggle
    $('.menu-icon').on('click', function() {
        $('.full-menu').toggleClass('active');
        $('body').toggleClass('menu-open');
    });

    // Close menu when clicking on a menu item
    $('.full-menu .items a').on('click', function() {
        $('.full-menu').removeClass('active');
        $('body').removeClass('menu-open');
    });

    // Gemeente autocomplete functionality
    var $searchInput = $('#search');
    var $searchForm = $searchInput.closest('.search-form');
    var $autocompleteList = null;
    var currentFocus = -1;
    var gemeentenCache = [];

    // Create autocomplete list element
    function createAutocompleteList() {
        if ($autocompleteList) {
            $autocompleteList.remove();
        }
        // Add notranslate class to prevent GTranslate from translating gemeente names
        $autocompleteList = $('<div class="autocomplete-list notranslate" translate="no"></div>');
        $searchForm.append($autocompleteList);
    }

    // Close autocomplete list
    function closeAutocompleteList() {
        if ($autocompleteList) {
            $autocompleteList.empty().hide();
        }
        currentFocus = -1;
    }

    // Highlight matching text
    function highlightMatch(text, searchTerm) {
        var regex = new RegExp('(' + searchTerm + ')', 'gi');
        return text.replace(regex, '<strong>$1</strong>');
    }

    // Show autocomplete suggestions
    function showSuggestions(gemeenten, searchTerm) {
        closeAutocompleteList();
        
        if (gemeenten.length === 0) {
            return;
        }

        createAutocompleteList();
        
        gemeenten.forEach(function(gemeente, index) {
            var $item = $('<div class="autocomplete-item"></div>');
            $item.html(highlightMatch(gemeente.title, searchTerm));
            $item.data('gemeente', gemeente);
            
            $item.on('click', function(e) {
                e.preventDefault();
                var selectedGemeente = $(this).data('gemeente');
                // Use titlePlain for the input value (no HTML tags)
                $searchInput.val(selectedGemeente.titlePlain || selectedGemeente.title.replace(/<[^>]*>/g, ''));
                closeAutocompleteList();
                // Navigate to gemeente page
                window.location.href = selectedGemeente.url;
            });
            
            $autocompleteList.append($item);
        });
        
        $autocompleteList.show();
    }
    

    // Fetch gemeenten from API
    function fetchGemeenten(searchTerm) {
        if (typeof vervoerzoekenData === 'undefined') {
            return;
        }

        var url = vervoerzoekenData.ajaxUrl;
        if (searchTerm) {
            url += '?search=' + encodeURIComponent(searchTerm);
        }

        $.ajax({
            url: url,
            method: 'GET',
            dataType: 'json',
            success: function(response) {
                gemeentenCache = response;
                showSuggestions(response, searchTerm);
            },
            error: function(xhr, status, error) {
                console.error('Autocomplete error:', error);
            }
        });
    }

    // Handle input event
    $searchInput.on('input', function() {
        var searchTerm = $(this).val().trim();
        
        if (searchTerm.length < 2) {
            closeAutocompleteList();
            return;
        }
        
        fetchGemeenten(searchTerm);
    });

    // Handle keyboard navigation
    $searchInput.on('keydown', function(e) {
        if (!$autocompleteList || $autocompleteList.children().length === 0) {
            return;
        }

        var $items = $autocompleteList.children();
        
        if (e.keyCode === 40) { // Down arrow
            e.preventDefault();
            currentFocus++;
            if (currentFocus >= $items.length) {
                currentFocus = 0;
            }
            setActive($items);
        } else if (e.keyCode === 38) { // Up arrow
            e.preventDefault();
            currentFocus--;
            if (currentFocus < 0) {
                currentFocus = $items.length - 1;
            }
            setActive($items);
        } else if (e.keyCode === 13) { // Enter
            if (currentFocus > -1) {
                e.preventDefault();
                $items.eq(currentFocus).click();
            }
        } else if (e.keyCode === 27) { // Escape
            closeAutocompleteList();
        }
    });

    // Set active item
    function setActive($items) {
        $items.removeClass('autocomplete-active');
        if (currentFocus >= 0 && currentFocus < $items.length) {
            $items.eq(currentFocus).addClass('autocomplete-active');
        }
    }

    // Close autocomplete when clicking outside
    $(document).on('click', function(e) {
        if (!$(e.target).closest('.search-form').length) {
            closeAutocompleteList();
        }
    });

    // Prevent form submission if autocomplete is open
    $searchForm.on('submit', function(e) {
        if ($autocompleteList && $autocompleteList.is(':visible') && currentFocus > -1) {
            e.preventDefault();
            $autocompleteList.children().eq(currentFocus).click();
        }
    });
});
